import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementDetails, SettlementTransaction } from 'src/app/models/settlement.model';
import { SettlementService } from 'src/app/services/settlement.service';

@Component({
  selector: 'app-settlement-details',
  templateUrl: './settlement-details.component.html',
  styleUrls: ['./settlement-details.component.scss']
})
export class SettlementDetailsComponent implements OnInit {
  settlement?: SettlementDetails;
  id: string = '';
  currency: string = '';

  // The whole transaction batch arrives in the details response; paging it here keeps a
  // 100-transaction settlement from rendering 100 rows without a second round trip.
  transactionsPageSize: number = 5;
  transactionsPage: number = 1;

  constructor(private route: ActivatedRoute, private toastr: ToastrService, private settlementService: SettlementService) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    this.currency = localStorage.getItem('currency') || '';
    this.getSelectedSettlement(parseInt(this.id));
  }

  get pagedTransactions(): SettlementTransaction[] {
    const start = (this.transactionsPage - 1) * this.transactionsPageSize;
    return this.settlement?.transactions?.slice(start, start + this.transactionsPageSize) ?? [];
  }

  get transactionsCount(): number {
    return this.settlement?.transactions?.length ?? 0;
  }

  transactionsPageChange(page: number): void {
    this.transactionsPage = page;
  }

  getStatusClass(status: string | undefined): string {
    switch (status) {
      case 'Successful': return 'approved-building';
      case 'Pending': return 'submitted-building';
      case 'Failed': return 'rejected-building';
      default: return 'assigned-building';
    }
  }

  getStatusKey(status: string | undefined): string {
    switch (status) {
      case 'Successful': return 'COMMON.SETTLEMENT_STATUS.SUCCESSFUL';
      case 'Pending': return 'COMMON.SETTLEMENT_STATUS.PENDING';
      case 'Failed': return 'COMMON.SETTLEMENT_STATUS.FAILED';
      default: return 'COMMON.SETTLEMENT_STATUS.UNKNOWN';
    }
  }

  getSelectedSettlement(id: number) {
    this.settlementService.getDetailsById(id).subscribe(
      (data) => {
        var response = data.body;
        if (response?.status === 'OK') {
          this.settlement = data?.body?.data as SettlementDetails;
        } else {
          this.toastr.error(response?.message);
        }
      },
      () => {
        this.toastr.error('An error ocurred.');
      }
    );
  }
}
